import styles from "./ActionButton.module.css";

type PropsType = {
  text: string;
  onClick: () => void;
  disabled?: boolean;
};

const ActionButton: React.FC<PropsType> = ({ text, onClick, disabled = false }) => {
  return (
    <button className={styles.openModalButton} onClick={onClick} disabled={disabled}>
      {text}
    </button>
  );
};

export default ActionButton;
